import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import {
  StarRating,
  ReviewCount,
  ShareIconButton,
} from '../../../components/widgets';

const useStyles = makeStyles({
  root: {
    width: '100%',
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
});

const WidgetBar = ({data}) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <StarRating rating={data.rating} />
      <ReviewCount count={data.review_count} />
      <ShareIconButton />
    </div>
  );
};

WidgetBar.propTypes = {
  data: PropTypes.object.isRequired,
};

export default WidgetBar;
